module.exports = __webpack_public_path__ + "static/media/bn.1d4e6091.svg";